import React, { Component } from "react";
import { Navigate } from 'react-router-dom';

export default class Logout extends Component {
    constructor(props) {
        super(props);
        localStorage.removeItem("token");
        localStorage.removeItem("user_role");
        localStorage.removeItem("client_tv_id");
        localStorage.removeItem("user_info");
        localStorage.removeItem("nanba_selected_station_id");
    }

    render() {

        return <Navigate to='/login'  />
    }
}
